import { useNavigate, useParams } from "@/router";
import { useEffect } from "react";
import { usePersonEventsAccess } from "./_usePersonEventsAccess";

export default function PersonEventsPage() {
  const { pgaId } = useParams("/people/:pgaId/events");
  const navigate = useNavigate();
  const { loaded, canViewPersonEvents } = usePersonEventsAccess();

  useEffect(() => {
    if (!loaded) return;
    if (!canViewPersonEvents) {
      navigate("/people/:pgaId/person/overview", { params: { pgaId }, replace: true });
      return;
    }
    navigate("/people/:pgaId/events/registrations", { params: { pgaId }, replace: true });
  }, [canViewPersonEvents, loaded, navigate, pgaId]);

  return null;
}
